<template>
  <el-switch v-bind="{ ...$attrs, ...props.config?.options }" />
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "form-switch",
  inheritAttrs: false,
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  emits: ["change"],
  setup(props) {
    const { t } = useI18n();
    return {
      t,
      props
    };
  }
});
</script>
